import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Un switch por cada modo de expediente. Los modos llegan por Input para que core no dependa
 * de modules: quien lo usa es el que los carga.
 */
@Component({
    selector: 'app-case-modes-switches',
    templateUrl: './case-modes-switches.component.html',
    styleUrls: ['./case-modes-switches.component.scss'],
    standalone: false
})
export class CaseModesSwitchesComponent {
  @Input() caseModes: any[] = [];
  @Input() selectedIds: string[] = [];
  @Input() disabled: boolean = false;

  @Output() selectedIdsChange: EventEmitter<string[]> = new EventEmitter<string[]>();

  public isSelected(caseModeId: string): boolean {
    return this.selectedIds.indexOf(caseModeId) >= 0;
  }

  public toggle(caseModeId: string, selected: boolean): void {
    //se emite un array nuevo para no mutar el del padre
    let ids = this.selectedIds.filter((id: string) => id != caseModeId);
    if (selected) ids.push(caseModeId);
    this.selectedIds = ids;
    this.selectedIdsChange.emit(ids);
  }
}
